export const languageName = [
  "c",
  "cpp",
  "python",
  "java",
  "kotlin",
  "scala",
  "swift",
  "csharp",
  "go",
  "haskell",
  "erlang",
  "perl",
  "ruby",
  "php",
  "bash",
  "r",
  "javascript",
  "coffeescript",
  "fsharp",
  "d",
  "clojure",
  "elixir",
  "rust",
  "scheme",
  "typescript",
  "objectivec",
  "visual-basic",
  "lisp",
];
